import React, { useEffect, useRef, useState } from 'react'
import './About.css'
import profile from '../Assets/about-pic.jpeg'

const About = () => {
  const aboutRef = useRef(null)
  const [show, setShow] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true)
        } else {
          setShow(false)
        }
      },
      { threshold: 0.25 }
    )

    if (aboutRef.current) {
      observer.observe(aboutRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={aboutRef} className={`about ${show ? 'show' : ''}`}>
      <div className='about-header'>
        <h1>About Me</h1>
        <img id='profile' src={profile} alt="" />
      </div>

      <div className='about-text'>
        <p>
          I’m a passionate web developer who enjoys turning ideas into clean,
          functional, and visually engaging digital experiences. I’m always
          learning, improving, and expanding my skills to stay current with
          modern development practices. I work with technologies such as HTML,
          CSS, JavaScript, React, Bootstrap, Node.js, and database tools to
          build responsive websites that look great and perform smoothly across
          devices. Every project is an opportunity for me to grow while
          delivering real value to the people I work with.
        </p>

        <p>
          What sets me apart is my drive to build with purpose and my commitment
          to getting the details right. I take pride in creating websites that
          not only look professional, but also help businesses connect with
          customers and grow online. I approach each project with creativity,
          reliability, and a mindset focused on solutions. When clients work
          with me, they can feel confident knowing they are hiring someone who
          is dedicated, motivated, and genuinely invested in bringing their
          vision to life.
        </p>
      </div>
    </div>
  )
}

export default About